import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=51f4445e&scoped=true"
var script = {}
import style0 from "./Test.vue?vue&type=style&index=0&id=51f4445e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f4445e",
  null
  
)

export default component.exports